import ContentTypes from "../../../../../lib/html5-software-library/src/ranj/eng/content/ContentTypes";
import MediatorManager from "../../../core/application/MediatorManager";
import SkinFactory from "../../../core/ui/SkinFactory";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import KeyDecision from "../../key-decisions/model/KeyDecision";
import HubKeyDecisionListItemMediator from "../view/HubKeyDecisionListItemMediator";

export default class HubKeyDecisionListItemFactory {
    /**
     * @console
     * @param {MediatorManager} mediatorManager
     */
    constructor(mediatorManager) {
        this._mediatorManager = mediatorManager;
    }

    /**
     * 
     * @param {createjs.Container} container 
     * @returns {HubKeyDecisionListItemMediator}
     */
    createHubLockedKeyDecisionListItemKey(container) {
        let keyDecisionListItemSkin = new lib.MainAssets.HubKeyDecisionNotification_Generic();
        container.addChild(keyDecisionListItemSkin);
        const mapMediator = this._mediatorManager.createMediator(keyDecisionListItemSkin, SkinKeyRegistry.HUB_KEY_DECISION_LIST_ITEM_SKIN);
        return mapMediator;
    }

    createFeedbackLockedKeyDecisionListItemKey(container, index) {
        let keyDecisionListItemSkin = new lib.MainAssets.FeedbackKeyDecisionNotification_Generic();
        container.addChild(keyDecisionListItemSkin);
        const mapMediator = this._mediatorManager.createMediator(keyDecisionListItemSkin, SkinKeyRegistry.HUB_KEY_DECISION_LIST_ITEM_SKIN);
        mapMediator.initializeAsFeedback(index);
        return mapMediator;
    }
}